import React, { useState } from 'react'
import GenericModal from '../../../components/GenericModal'
import CsvMappingUpload from '../../../components/CsvMappingUpload'
import Dropdown from '../../../components/Dropdown'
import { ButtonType } from '../../../components/GenericButton/styles'
import { notification } from '../../../components/Notifications'
import CreateAndEditStudents from '../CreateAndEditStudents'
import { type ApplyFiltersAndDispatchParams, TableModalAction } from '../../../components/CustomTable/types'

interface StudentsTopbarActionsProps {
  allowedActions?: string[]
  params: ApplyFiltersAndDispatchParams
  setUploadTaskId: (id: string | null) => void
  isTaskRunning: boolean
  onTaskBlock: () => void
}

const StudentsTopbarActions: React.FC<StudentsTopbarActionsProps> = ({ allowedActions = [], params, setUploadTaskId, isTaskRunning, onTaskBlock }) => {
  const [isUploadModal, setIsUploadModal] = useState<boolean>(false)
  const [isCreateModal, setIsCreateModal] = useState<boolean>(false)

  const closeUploadModal = (): void => {
    setIsUploadModal(false)
  }

  const uploadApi = (): void => {
    if (isTaskRunning) { onTaskBlock(); return }
    setIsUploadModal(true)
  }

  const addManually = (): void => {
    if (isTaskRunning) { onTaskBlock(); return }
    setIsCreateModal(true)
  }

  const menuItems = [
    { text: 'Upload Students (.csv)', action: uploadApi },
    { text: 'Add Manually', action: addManually }
  ]

  return (
    <>
      {allowedActions?.includes(TableModalAction.CREATE) && <Dropdown menuItems={menuItems} label='Add Student' extraButtonProps={{ buttonType: ButtonType.Primary }} />}
      <GenericModal
        isOpen={isCreateModal}
        title={'Add Student'}
        onClose={() => { setIsCreateModal(false) }}
        maxWidth='sm'
        action={false}
      >
        <CreateAndEditStudents handleCloseModal={() => { setIsCreateModal(false) }} params={params} />
      </GenericModal>

      <CsvMappingUpload isOpen={isUploadModal} onClose={closeUploadModal} modalTitle="Students" csvHeaderEndpoint="/api/users/csv_headers" uploadCsvEndpoint="/api/users/?is_student=True" hasCreatePermission={allowedActions?.includes(TableModalAction.CREATE)} returnTaskId={(id) => { if (id) setUploadTaskId(id) }} onSuccess={() => {
        notification('Students successfully uploaded', { variant: 'success' })
      }} />
    </>
  )
}

export default StudentsTopbarActions
